<!-- 新增 / 编辑 课程 -->
<template>
  <div class="apply">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基础信息：</div>
        <div class="container">
          <el-form-item class="item" label="课程名称：" prop="courseName">
            <el-input v-model="ruleForm.courseName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="课程分类：" prop="categoryId">
            <el-cascader :options="categoryOptions" placeholder="选择分类" v-model="ruleForm.categoryId"
              :props="cascaderprops" collapse-tags clearable @change="handleSelectCategory"></el-cascader>
          </el-form-item>
          <el-form-item class="item" label="课程专家：" prop="teacherId">
            <el-select v-model="ruleForm.teacherId" placeholder="请选择" clearable @change="handleSelectTeacher">
              <el-option v-for="item in teacherNameOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="item" label="是否推荐：" prop="courseLabel">
            <el-select v-model="ruleForm.courseLabel" placeholder="请选择" clearable>
              <el-option v-for="item in recommendOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="item" label="课程标签：" prop="courseLabel">
            <el-select v-model="ruleForm.courseLabel" placeholder="请选择标签" clearable>
              <el-option v-for="item in recommendOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="排序：" prop="sort">
            <el-input v-model="ruleForm.sort" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item logo_pic" label="课程封面：" prop="coursePic">
            <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUploads"
              :on-remove="handleRemoveLogo" :disabled="ruleForm.coursePic ? true : false" :headers="headers">
              <img v-if="ruleForm.coursePic" :src="ruleForm.coursePic" class="logoimg">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.coursePic" class="delpic el-icon-error" @click="handleRemoveLogo"></i>
          </el-form-item>
        </div>
        <div class="title">价格信息：</div>
        <div class="container">
          <el-form-item class="item" label="是否收费：" prop="costAttr">
            <el-select v-model="ruleForm.costAttr" placeholder="请选择" clearable>
              <el-option v-for="item in costAttrOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="container" v-if="ruleForm.costAttr == 1">
          <el-form-item class="item" label="课程价格：" prop="price">
            <el-input v-model="ruleForm.price" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="购买有效期：" prop="effectiveDay">
            <el-radio-group v-model="ruleForm.effectiveDay" @change="handleEffectiveDayChange">
              <el-radio :label="1">不限</el-radio>
              <el-radio :label="2">
                限制
                <el-input v-model="ruleForm.limitDay" placeholder="请输入" :disabled="ruleForm.effectiveDay === 1"
                  style="width: 100px; margin:0px 10px;"></el-input>
                天
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="title">课程简介:</div>
        <div class="container">
          <el-form-item class="" label="" prop="introduce" label-width="80px">
            <editor :htmls="ruleForm.introduce" @change="onChange" />
          </el-form-item>
        </div>
        <div class="submit-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
export default {
  components: {
    editor
  },
  data() {
    return {
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        value: "id",
        label: "categoryName",
        children: "children",
      },
      categoryOptions: [], // 分类options
      teacherNameOptions: [], // 专家options
      // 是否推荐options
      recommendOptions: [
        {
          label: '无',
          value: 0
        },
        {
          label: '最新',
          value: 1
        },
        {
          label: '热门',
          value: 2
        },
        {
          label: '推荐',
          value: 3
        },
      ],
      // recommendOptions: [
      //   {
      //     label: '是',
      //     value: 1
      //   },
      //   {
      //     label: '否',
      //     value: 0
      //   },
      // ],
      // 是否收费options
      costAttrOptions: [{
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      },
      ],
      ruleForm: {
        courseName: '',
        categoryName: '',
        teacherId: '',
        costAttr: 1,
        price: '',
        effectiveDay: 1, // 默认不限
        limitDay: '',
        coursePic: '',
        introduce: '',
        courseLabel: '',
        sort: ''
      },
      rules: {
        courseName: [{
          required: true,
          message: '请输入课程名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择课程分类',
          trigger: 'blur'
        }],
        teacherId: [{
          required: true,
          message: '请选择课程专家',
          trigger: 'blur'
        }],
        costAttr: [{
          required: true,
          message: '请选择是否收费',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入课程价格',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字',
          trigger: 'blur'
        }],
        effectiveDay: [{ required: true, message: '请选择购买有效期', trigger: 'change' }],
        limitDay: [
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.effectiveDay === 2) {
                if (!value) {
                  callback(new Error('限制天数不能为空'));
                } else if (isNaN(value) || parseInt(value) <= 0) {
                  callback(new Error('请输入大于0的整数'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        courseLabel: [{
          required: true,
          message: '请选择课程标签',
          trigger: 'blur'
        }],
        coursePic: [{
          required: true,
          message: '请上传课程图片',
          trigger: 'blur'
        }],
        sort: [{
          pattern: /^[1-9]\d*$/,
          message: '排序只能输入正整数',
          trigger: 'blur'
        }],
      },
      // 图片上传
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: {
        token: this.$store.state.token,
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "编辑课程";
    } else {
      to.meta.title = "新增课程";
    }
    next();
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title;
    },
    'ruleForm.costAttr': function (newVal) {
      if (newVal == 0) { // 如果选择了免费课程
        this.ruleForm.price = 0;
        this.ruleForm.effectiveDay = 1;
        this.ruleForm.limitDay = "";
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.selectCourseInfoDetail()
    }
    this.getCategoryList()
    this.selectListByTeacher()
  },

  methods: {
    onChange(value) {
      this.ruleForm.introduce = value
    },
    handleEffectiveDayChange(val) {
      if (val === 1) {
        this.ruleForm.limitDay = '';
      } else if (val === 2 && !this.ruleForm.limitDay) {
        this.ruleForm.limitDay = null;
      }
    },
    // 分类
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.categoryOptions = this.processCategoryData(res.result.list)
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    processCategoryData(data) {
      function processItems(items, level) {
        for (let item of items) {
          if (level === 3) {
            delete item.children;
          } else if (item.children && item.children.length > 0) {
            processItems(item.children, level + 1);
          }
        }
      }
      const processedData = JSON.parse(JSON.stringify(data));
      processItems(processedData, 1); // 从第一层开始处理
      return processedData;
    },
    handleSelectCategory(value) {
      this.$set(this.ruleForm, "categoryId", value)
    },
    selectListByTeacher() {
      this.$axios
        .get(this.$api.selectListByTeacher)
        .then(res => {
          if (res.code == 100) {
            this.teacherNameOptions = res.result.map(item => {
              return {
                label: item.teacherName,
                value: item.id
              }
            })
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleSelectTeacher(value) {
      const selectedTeacher = this.teacherNameOptions.find(item => item.value === value);
      if (selectedTeacher) {
        this.ruleForm.teacherName = selectedTeacher.label;
      }
    },
    // 编辑详情
    selectCourseInfoDetail() {
      this.$axios.get(this.$api.selectCourseInfoDetail, {
        params: { id: this.$route.query.id }
      }).then(res => {
        if (res.code === 100) {
          const row = res.result;
          this.ruleForm = row;
          this.$set(this.ruleForm, 'courseName', row.courseName);
          this.$set(this.ruleForm, 'categoryId', row.categoryId);
          this.$set(this.ruleForm, 'teacherId', row.teacherId);
          this.$set(this.ruleForm, 'courseLabel', row.courseLabel);
          this.$set(this.ruleForm, 'sort', row.sort);
          this.$set(this.ruleForm, 'coursePic', row.coursePic);
          this.$set(this.ruleForm, 'costAttr', row.costAttr);
          this.$set(this.ruleForm, 'price', row.price);
          this.$set(this.ruleForm, 'introduce', row.introduce);

          if (row.effectiveDay !== null && row.effectiveDay !== undefined) {
            this.$set(this.ruleForm, 'limitDay', row.effectiveDay);
            this.$set(this.ruleForm, 'effectiveDay', 2);
          } else {
            this.$set(this.ruleForm, 'effectiveDay', 1);
            this.$set(this.ruleForm, 'limitDay', '');
          }

        }
      }).catch(err => {
        this.$message.error(err.desc);
      });
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.costAttr == 0) {
            this.ruleForm.effectiveDay = 1;
            this.ruleForm.price = 0;
          }
          // if (this.ruleForm.costAttr == 1 && this.ruleForm.price == 0) {
          //   this.$message.warning('付费情况下价格不能为0')
          //   return
          // }

          // 处理有效期字段
          let effectiveDay = null;
          if (this.ruleForm.effectiveDay === 2) {
            effectiveDay = this.ruleForm.limitDay;
          }

          const formData = {
            categoryId: this.ruleForm.categoryId,
            costAttr: this.ruleForm.costAttr,
            courseName: this.ruleForm.courseName || null,
            coursePic: this.ruleForm.coursePic || null,
            effectiveDay: effectiveDay,
            introduce: this.ruleForm.introduce || null,
            courseLabel: this.ruleForm.courseLabel,
            price: this.ruleForm.price,
            teacherName: this.ruleForm.teacherName || null,
            teacherId: this.ruleForm.teacherId || null,
            sort: this.ruleForm.sort || null,
          }
          if (this.$route.query.id) {
            // 如果存在 this.$router.query.id
            formData.id = this.$route.query.id
            this.$axios
              .post(this.$api.updateCourseInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 insertCourseInfo
            this.$axios
              .post(this.$api.insertCourseInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      // const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 5MB!")
      // }
      // return isJPG && isLt5M
      return isJPG
    },
    handleRemoveLogo() {
      this.ruleForm.coursePic = ""
    },
    handleSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.coursePic = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.form {
  margin: 30px 20px;

  .title {
    font-size: 18px;
    margin-left: 60px;
    padding-bottom: 15px;
    padding-left: 20px;
    margin-bottom: 10px;
    font-weight: bold;
    border-bottom: 1px solid #E5E7E6;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    font-size: 16px;
    color: #707070;

    ::v-deep .el-form-item__label {
      color: #272727;
      font-size: 16px;
      padding-right: 15px;
    }

    .el-input,
    .el-select,
    .el-cascader,
    .el-date-editor {
      width: 300px;
    }

    .el-input-number {
      width: 300px;

      ::v-deep .el-input-number__decrease {
        border-radius: 10px 0 0 10px !important;
      }

      ::v-deep .el-input-number__increase {
        border-radius: 0 10px 10px 0 !important;
      }
    }
  }

  .item {
    width: 30%;
    /* 100% / 3 = 33.33%，留一点空间避免浏览器计算误差 */
    margin-bottom: 30px;
    margin-right: 30px;
  }

  .container .item:nth-last-child(-n+3) {
    margin-bottom: 0;
  }
}

.submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 100px;
}


// 图片
.logo_pic {
  position: relative;

  ::v-deep .el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .logo_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    .logoimg {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic {
    position: absolute;
    top: -12px;
    left: 90px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
